import React from "react";
import { Row, Col, Button } from "reactstrap";
import Player from "../../../../../assets/images/OCH/player.png";
import Cross from "../../../../../assets/images/verboden/cross.png";
import { compose } from "redux";
import { connect } from "react-redux";
import { withSocket } from "../../../../../socket/context";
import _ from "lodash";
import { removeUser } from "../../../../../components/shared/utils";
import XIcon from "../../../../../assets/images/OCH/X.png";
import Winner from "../../../../../assets/images/OCH/winner.png";
import avatar from "../../../../../assets/images/OCH/avatar.png";
const FinalPlayers = (props) => {
  const roomData = _.get(props, "gameReducer.roomObj");
  const users = _.get(roomData, "users");
  const players = _.get(roomData, "game_state.players");
  const roundWinner = _.get(roomData, "game_state.round_winner");
  const winner = _.filter(users, (item) => item.player_id === roundWinner);
  // const winner = _.filter(players, (item) => {
  //   if (item.player_hand.length === 0) {
  //     return item;
  //   }
  // });

  const delPlayer = (data) => {
    const roomObj = roomData;
    removeUser(roomObj, data);
  };
  return (
    <>
      <Row>
        {users &&
          users.length > 0 &&
          users.map((user) => {
            if (user?.player_id === winner[0]?.player_id) {
              return (
                <Col md={3} className="px-xl-2 px-1">
                  <div className="och-players-box active m-0 result-boxes">
                    <div className="och-player-image-wrapper">
                      <img
                        src={
                          user.profile_image
                            .toString()
                            .includes("default-profile-icon")
                            ? avatar
                            : user.profile_image
                                .toString()
                                .includes("profileImage")
                            ? avatar
                            : user.profile_image
                                .toString()
                                .includes("profileImage")
                            ? avatar
                            : user.profile_image
                        }
                        className="och-player-image"
                      />
                      <Button
                        color="ochTheme"
                        className="cross-btn"
                        onClick={() => delPlayer(user)}
                      >
                        <img src={XIcon} />
                      </Button>
                    </div>

                    <h3 className="och-player-name">{user.display_name}</h3>
                  </div>
                  <div className="och-players-scores-wapper active mt-3">
                    <img className="winnerImage" src={Winner} />
                  </div>
                </Col>
              );
            } else {
              let player = players.find(
                (play) => user.player_id === play.player_id
              );
              const dummyArr = [];
              const obj = {};
              let total = 0;
              for (let card of player.player_hand) {
                let cardnumber = "";
                if (
                  card.number === 10 ||
                  card.number === 11 ||
                  card.number === 12 ||
                  card.number === 13
                ) {
                  cardnumber = 10;
                } else if (card.number === 8) {
                  cardnumber = 50;
                } else {
                  cardnumber = card.number;
                }
                obj[card.number] = obj[card.number] ? obj[card.number] + 1 : 1;
                dummyArr.push({ number: card.number, cardnumber });
              }
              const final = [];
              function returnTotal(obj) {
                let faceCardTotal = 0;
                let otherCardTotal = 0;
                let aces = 0;
                _.forOwn(obj, function (value, key) {
                  if (key === "11" || key === "12" || key === "13") {
                    faceCardTotal += parseInt(value);
                  } else if (key === "1") {
                    aces = value;
                  } else {
                    otherCardTotal = value;
                  }
                });
                return {
                  faceCardTotal: faceCardTotal,
                  otherCardTotal: otherCardTotal,
                  aces: aces,
                };
              }
              const faceCardLen = returnTotal(obj);
              dummyArr.forEach((i) => {
                if (i.number === 11 || i.number === 12 || i.number === 13) {
                  final.push({
                    number: `KQJ`,
                    cardnumber: 10,
                    cardLength: faceCardLen.faceCardTotal,
                    sortValue: 12,
                  });
                } else if (i.number === 1) {
                  final.push({
                    number: `Aces`,
                    cardnumber: 1,
                    cardLength: faceCardLen.aces,
                    sortValue: 1,
                  });
                } else if (i.number === 8) {
                  final.push({
                    ...i,
                    cardLength: obj[i.number],
                    sortValue: 15,
                  });
                } else {
                  final.push({
                    ...i,
                    cardLength: obj[i.number],
                    sortValue: i.number,
                  });
                }
              });
              let jsonObject = final.map(JSON.stringify);
              let uniqueSet = new Set(jsonObject);
              let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
              uniqueArray.sort((a, b) => {
                return b.sortValue - a.sortValue;
              });
              console.log(uniqueArray, "uniqueArrayuniqueArray");
              return (
                <Col md={3} className="px-xl-2 px-1">
                  <div className="och-players-box m-0 result-boxes">
                    <div className="och-player-image-wrapper">
                      <img
                        src={
                          user.profile_image
                            .toString()
                            .includes("default-profile-icon")
                            ? avatar
                            : user.profile_image
                                .toString()
                                .includes("profileImage")
                            ? avatar
                            : user.profile_image
                                .toString()
                                .includes("profileImage")
                            ? avatar
                            : user.profile_image
                        }
                        className="och-player-image"
                      />
                      <Button
                        color="ochTheme"
                        className="cross-btn"
                        onClick={() => delPlayer(user)}
                      >
                        {" "}
                        <img src={XIcon} />
                      </Button>
                    </div>

                    <h3 className="och-player-name">{user.display_name}</h3>
                  </div>
                  <div className="och-players-scores-wapper mt-3">
                    <div>
                      {uniqueArray.map((i) => {
                        const { number, cardnumber, cardLength } = i;
                        total = total + cardnumber * cardLength;
                        return (
                          <>
                            <div className="och-players-scores">
                              <div className="och-player-row">
                                <div className="och-player-col1">
                                  <div className="players-scores">
                                    <p className="name">
                                      {number}
                                      {number === "Aces" ? ":" : "s:"}
                                    </p>
                                    <p className="scores scores-left">
                                      {cardnumber}
                                    </p>
                                  </div>
                                </div>
                                <div className="och-player-col">
                                  <div className="players-scores">
                                    <p className="name x50">
                                      <span className="smallX">X</span>{" "}
                                      {cardLength}
                                    </p>
                                    <p className="scores scores-right ">
                                      ={" "}
                                      <span className="pl-1">
                                        {cardnumber * cardLength}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                    <div className="och-players-scores total">
                      <span className="name">Total</span>
                      <span className="scores"> = {total}</span>
                    </div>
                  </div>
                </Col>
              );
            }
          })}
      </Row>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default compose(
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(FinalPlayers);
